import React, { useState, useEffect, useContext } from 'react';
import { getGolfersFromTaskId, ChangePlayerSession, CopyCurrentSession, CopyCurrentSessionWithTest, getSessionsFromTaskId, getSessionFromId, ChangeSession } from '../isdlData/sessionData';
import { GetUser } from '../isdlData/matrixUserData';
import UserDisplay from './UserDisplay';
import UserList from './UserList';
import { Modal } from '@mui/material';
import { ViewOnlyContext } from '../contexts/AppContext';
import Select from 'react-select';
import { GetBallTests } from '../isdlData/constantsData';


function GolferDisplay({ CurrentSession, SessionChanged, Disabled }) {

    const [hasTaskId, setHasTaskId] = useState(false);
    const [sessionList, setSessionList] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [newUserFormVisible, setNewUserFormVisible] = useState(false);
    const [loadingUsers, setLoadingUsers] = useState(true);
    const [ballTestOptions, setBallTestOptions] = useState([]);
    const [selectedTestOption, setSelectedTestOption] = useState(null);
    const [newTestName, setNewTestName] = useState("");
    const [showCustomTestInput, setShowCustomTestInput] = useState(false);

    const [newGolferSelected, setNewGolferSelected] = useState(null);
    const [golferExists, setGolferExists] = useState(false);

    const [DCElevatedRole, setDCElevatedRole] = useState(false);

    const { viewOnly } = useContext(ViewOnlyContext);
    const entityLabel = CurrentSession?.EntityType === "Test" ? "Test" : "Golfer";
    const canAddEntity = true;

    const [refuseUpdate, setRefuseUpdate] = useState(false);

    useEffect(() => {
        let mounted = true;

        const loadBallTests = async () => {
            const tests = await GetBallTests();

            if (mounted) {
                setBallTestOptions(Array.isArray(tests) ? tests : []);
            }
        };

        loadBallTests();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        const loadSessions = async () => {
            if(refuseUpdate){
                return;
            }
            // const sessionIds = await getSessionsFromTaskId(CurrentSession.TaskID);
            const userIds = await getGolfersFromTaskId(CurrentSession.TaskID);
            // let sessions = await Promise.all(sessionIds.map(async sessionid => {
            //     return await getSessionFromId(sessionid);
            // }));

            const users = Array.isArray(userIds) ? userIds : [userIds];

            setSessionList(users);
            setLoadingUsers(false);

            if (CurrentSession.DataCollectorId) {
                const dcUser = await GetUser(CurrentSession.DataCollectorId.toLowerCase());

                if (dcUser === null || dcUser === undefined) {
                    return;
                }

                setDCElevatedRole(dcUser.Role === "Admin" || dcUser.Role === "Fitter" || dcUser.Role === "DataCollector");
            }

            setSelectedUser(CurrentSession.id);
        }




        if (CurrentSession.TaskID) {
            setLoadingUsers(true);
            setHasTaskId(true);
            loadSessions();
        } else {
            setHasTaskId(false);
            setSelectedUser(CurrentSession.UserId);
        }

    }, [CurrentSession, refuseUpdate]);

    const handleChange = async (e) => {
        const selectedValue = e.target.value;
        setSelectedUser(selectedValue);

        if (selectedValue === 'add-new-user') {
            handleAddNewUser();
        } else {
            const loadedSession = await ChangeSession(selectedValue);
            // const loadedSession = await ChangePlayerSession(selectedValue, CurrentSession.DataCollectorId, CurrentSession.TaskID);
            SessionChanged(loadedSession);
        }
    };

    const handleAddNewUser = () => {
        setSelectedUser('');
        setNewUserFormVisible(true);
        setSelectedTestOption(null);
        setNewTestName("");
        setShowCustomTestInput(false);
    };

    const handleGolferSelected = (data) => {
        setNewGolferSelected(data);

        if (data === null) {
            return;
        }

        const userAlreadyExists = sessionList.some(session => session.UserId === data.id);
        setGolferExists(!userAlreadyExists);
    };

    const handleGolferFinished = async () => {
        setRefuseUpdate(true);
        const userAlreadyExists = sessionList.some(session => session.UserId === newGolferSelected.id);

        if (userAlreadyExists) {
            alert('The user selected already exists in the current session.');
            return;
        }

        const newSession = await CopyCurrentSession(newGolferSelected);
        // await new Promise(resolve => setTimeout(resolve, 800));
        setNewGolferSelected(null);
        setNewUserFormVisible(false);
        SessionChanged(newSession);
        setRefuseUpdate(false);
    };

    const handleTestSelectChange = (option) => {
        setSelectedTestOption(option);
        setShowCustomTestInput(option?.value === 'add-new-test');

        if (option?.value !== 'add-new-test') {
            setNewTestName("");
        }
    };

    const getResolvedTestSelection = () => {
        if (showCustomTestInput) {
            const trimmedName = newTestName.trim();
            if (trimmedName === "") {
                return null;
            }

            return {
                value: `custom-${trimmedName.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
                label: trimmedName,
            };
        }

        if (!selectedTestOption) {
            return null;
        }

        return selectedTestOption;
    };

    const handleTestFinished = async () => {
        const resolvedTest = getResolvedTestSelection();
        if (!resolvedTest) {
            return;
        }

        setRefuseUpdate(true);
        const testAlreadyExists = sessionList.some(session => session.UserId === resolvedTest.value || session.UserName === resolvedTest.label);

        if (testAlreadyExists) {
            alert('The test selected already exists in the current session.');
            setRefuseUpdate(false);
            return;
        }

        const newSession = await CopyCurrentSessionWithTest(resolvedTest);
        setSelectedTestOption(null);
        setNewTestName("");
        setShowCustomTestInput(false);
        setNewUserFormVisible(false);
        SessionChanged(newSession);
        setRefuseUpdate(false);
    };

    function GetAddGolferButtonStatus() {
        let status = true;

        if (newGolferSelected == null) {
            status = false;
        }

        if (golferExists) {
            status = false;
        }

        return status;
    }

    return (
        <>
            {hasTaskId && (
                <div style={{ height: '40px', width: '100%' }}>
                    <select value={selectedUser} onChange={handleChange} style={{ height: '100%', width: '100%' }} disabled={loadingUsers || Disabled}>
                        {/* {userList.map((user) => (
                    <option key={user.id} value={user.id}>
                        {user.FullName}
                    </option>
                    ))} */}

                        {sessionList.map((session) => (
                            <option key={session.id} value={session.id}>
                                {session.UserName}
                            </option>
                        ))}

                        {!viewOnly && canAddEntity && (
                            <>
                                <option disabled>──────────</option> {/* Separator */}
                                <option value="add-new-user">Add New {entityLabel}</option>
                            </>
                        )}

                    </select>
                </div>
            )}
            {!hasTaskId && (
                <div style={{ width: '100%', textAlign: 'center' }}>
                    {CurrentSession.UserName}
                </div>
            )}

            <Modal
                open={newUserFormVisible}>
                <div className='new-golfer-container'>
                    <div style={{ width: '100%' }}>
                        {CurrentSession?.EntityType === "Test" ? (
                            <div style={{display:'flex', flexDirection:'column', gap:'10px', width:'100%'}}>
                                <Select
                                    options={ballTestOptions}
                                    value={selectedTestOption}
                                    onChange={handleTestSelectChange}
                                    placeholder="Use pulldown arrow to add tests"
                                    isSearchable={false}
                                    isClearable={false}
                                    classNamePrefix='search-input'
                                    menuPortalTarget={document.body}
                                    menuPosition='fixed'
                                    styles={{
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                        }),
                                        option: (base, { isFocused, isSelected }) => ({
                                            ...base,
                                            backgroundColor: isFocused || isSelected ? getComputedStyle(document.documentElement).getPropertyValue('--selected-highlight') : getComputedStyle(document.documentElement).getPropertyValue('--input-background'),
                                            color: isFocused || isSelected ? getComputedStyle(document.documentElement).getPropertyValue('--input-background') : getComputedStyle(document.documentElement).getPropertyValue('--input-foreground'),
                                        }),
                                    }}
                                />
                                {showCustomTestInput && (
                                    <input
                                        className='input'
                                        type='text'
                                        value={newTestName}
                                        onChange={(e) => setNewTestName(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' && newTestName.trim() !== "") {
                                                e.preventDefault();
                                                handleTestFinished();
                                            }
                                        }}
                                        placeholder='Enter test name'
                                        style={{width:'100%'}}
                                    />
                                )}
                            </div>
                        ) : (
                            <UserList dbInitialized={true} UserChanged={handleGolferSelected} LoadedUser={null} HasEditPermission={DCElevatedRole} />
                        )}
                    </div>
                    {/* <div>
                            <strong>
                                Golfer Selected:
                            </strong>
                        </div>
                        <UserDisplay User={newGolferSelected} /> */}
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 'auto' }}>
                        <button className='button' style={{ marginBottom: '5px' }} onClick={() => setNewUserFormVisible(false)}>Close</button>
                        <button
                            className='button'
                            style={{ marginBottom: '5px' }}
                            onClick={() => CurrentSession?.EntityType === "Test" ? handleTestFinished() : handleGolferFinished()}
                            disabled={CurrentSession?.EntityType === "Test" ? getResolvedTestSelection() === null : GetAddGolferButtonStatus()}
                        >
                            Add
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default GolferDisplay;
